module.exports = __webpack_public_path__ + "media/images/arrow_light-77255f11cff74b272ff31161446fe50b.svg";